import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function LatestUpdates() {
  const latest = [...articles].sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()).slice(0, 6);

  return (
    <section className="py-12 md:py-14 bg-background-50">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-8">
          <div>
            <h2 className="font-heading text-xl md:text-2xl font-semibold text-foreground-900 mb-1">
              最新动态
            </h2>
            <p className="text-sm text-foreground-500">第一时间了解佐山爱的最新消息</p>
          </div>
          <Link
            to="/category/news"
            className="whitespace-nowrap cursor-pointer text-sm text-primary-600 hover:text-primary-700 font-label flex items-center gap-1"
          >
            更多动态 <i className="ri-arrow-right-line text-xs"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {latest.map((article) => (
            <Link
              key={article.id}
              to={`/article/${article.id}`}
              className="group flex gap-4 p-4 rounded-xl bg-background-100 border border-background-200/50 hover:border-background-300/80 transition-all cursor-pointer"
            >
              <div className="w-20 h-20 md:w-24 md:h-24 flex-shrink-0 rounded-lg overflow-hidden">
                <img
                  src={article.coverImage}
                  alt={article.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-400"
                />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1.5">
                  <span className="text-xs text-accent-600 font-label bg-accent-50 px-2 py-0.5 rounded-full">
                    {article.category === 'profile' ? '资料' :
                     article.category === 'gravure' ? '写真' :
                     article.category === 'film' ? '影视' :
                     article.category === 'news' ? '动态' : '访谈'}
                  </span>
                  <span className="text-xs text-foreground-400">{article.date}</span>
                </div>
                <h3 className="font-heading text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-2 leading-snug">
                  {article.title}
                </h3>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}